import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface SignInState {
    isSignIn: boolean,
    loading: boolean,
    token: string,
    userData: {
        username?: string,
        displayName?: string,
        email?: string
    }
}

const initialState: SignInState = {
    isSignIn: false,
    loading: false,
    token: '',
    userData: {}
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        signIn: (state, action) => {
            state.loading = true;
        },
        signInSuccess: (state, action) => {
            state.isSignIn = true;
            state.loading = false;
            state.token = action.payload.data.token;
            
            // Store user data if available in the response
            if (action.payload.data.user) {
                state.userData = action.payload.data.user;
            }
        },
        signInFailure: (state, action: PayloadAction<string>) => {
            state.isSignIn = false;
            state.loading = false;
            state.token = "";
            state.userData = {};
        },
        signOut: (state) => {
            state.isSignIn = false;
            state.token = "";
            state.userData = {};
        }
    },
})

export const { signIn, signInSuccess, signInFailure, signOut } = authSlice.actions

export default authSlice.reducer